var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-pos-rel"},[_vm._t("default"),_c('v-overlay',{attrs:{"value":_vm.overlay,"color":"white","absolute":""}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }